import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/atlassian/pipelines/agent/build/platform/services/design-system-docs/src/__DO_NOT_ADD_TO_THIS_FOLDER__/gatsby-theme-brisk/templates/page.tsx";
import { Stack } from '@atlaskit/primitives';
import { IconCardGroup } from '@af/design-system-docs-ui';
import { VideoPlayer } from '../../../components/video-player';
import { GuidanceCard } from '../../../components/guidance-cards/guidance-cards';
import { guidanceCardComponents, guidanceCardContent, guidanceCardDesigningMessages, guidanceCardFigmaLibrariesPage, guidanceCardAssetLibrary, guidanceCardWritingToolkit, guidanceCardSAC, guidanceCardTrainingFigma, guidanceCardTrainingADS, guidanceCardTrainingA11y } from '../../../components/guidance-cards/guidance-card-content';
import { contactUsCards } from '../../contact-us';
import { QuoteCard, quoteCard1, quoteCard2, quoteCard3 } from '../../../components/quote-cards/quote-cards';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2 {...{
      "id": "how-content-designers-use-the-design-system"
    }}>{`How content designers use the design system`}</h2>
    <p>{`Atlassian Design System (ADS) is the core framework that powers Atlassian app user interfaces. Most
teams use the ADS foundation content guidelines alongside other global standards and team standards
(for example, AI content standards).`}</p>
    <p>{`There are other app-specific components developed by teams to use with ADS. These are documented in
Atlaskit (for example, Confluence Editor).`}</p>
    <p><a parentName="p" {...{
        "href": "https://atlaskit.atlassian.com/"
      }}>{`Atlaskit platform components`}</a></p>
    <h2 {...{
      "id": "learn-about-atlassian-content-guidelines"
    }}>{`Learn about Atlassian content guidelines`}</h2>
    <p>{`Atlassian Design System is the home of content standards for app interfaces.`}</p>
    <p>{`Get started writing and designing UI content with these guidelines:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://atlassian.design/content/voice-tone"
        }}>{`Voice and tone`}</a>{`: Create content that aligns with the
Atlassian voice and tone.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://atlassian.design/content/inclusive-writing"
        }}>{`Inclusive language`}</a>{`: Show respect and value
for everyone, acknowledging diversity.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://atlassian.design/content/language-and-grammar"
        }}>{`Language and grammar`}</a>{`: Use conventions for
clear, consistent, and localizable writing.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://atlassian.design/content/date-time"
        }}>{`Date and time`}</a>{`: Communicate date and time in a clear,
consistent, unambiguous way.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://go.atlassian.com/vocab"
        }}>{`Atlassian vocabulary (Atlassians only)`}</a>{`: The official glossary
and wordlist for Atlassian app terminology.`}</li>
    </ul>
    <GuidanceCard card={guidanceCardContent} mdxType="GuidanceCard" />
    <h2 {...{
      "id": "follow-content-guidance-for-components"
    }}>{`Follow content guidance for components`}</h2>
    <p>{`Write and design content for UIs with these content guidelines from the Atlassian Design System.`}</p>
    <p>{`Browse some of the component usage guidelines:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://atlassian.design/components/button/usage"
        }}>{`Button`}</a>{`: Let users know what will happen when a
button triggers an event or action.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://atlassian.design/components/form/usage"
        }}>{`Form`}</a>{`: Allows users to input information on a
form.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://atlassian.design/components/modal-dialog/usage"
        }}>{`Modal dialog`}</a>{`: Display content that
requires user interaction, in a layer above the page.`}</li>
    </ul>
    <Stack space="space.150" mdxType="Stack">
	<GuidanceCard card={guidanceCardComponents} mdxType="GuidanceCard" />
	<GuidanceCard card={guidanceCardDesigningMessages} mdxType="GuidanceCard" />
    </Stack>
    <h2 {...{
      "id": "access-figma-libraries-and-brand-assets"
    }}>{`Access Figma libraries and brand assets`}</h2>
    <Stack space="space.150" mdxType="Stack">
	<GuidanceCard card={guidanceCardFigmaLibrariesPage} mdxType="GuidanceCard" />
	<GuidanceCard card={guidanceCardAssetLibrary} mdxType="GuidanceCard" />
    </Stack>
    <h2 {...{
      "id": "discover-atlassians-guidelines-for-documentation"
    }}>{`Discover Atlassian’s guidelines for documentation`}</h2>
    <p>{`Atlassian Design System has standards and guidelines for UI copy in Atlassian apps. Other Atlassian
teams maintain the technical and support documentation standards.`}</p>
    <Stack space="space.150" mdxType="Stack">
	<GuidanceCard card={guidanceCardWritingToolkit} mdxType="GuidanceCard" />
	<GuidanceCard card={guidanceCardSAC} mdxType="GuidanceCard" />
    </Stack>
    <h2 {...{
      "id": "training-courses-for-atlassians"
    }}>{`Training courses for Atlassians`}</h2>
    <p>{`Get started with Absorb courses about Figma, the design system, and accessible content design.`}</p>
    <Stack space="space.150" mdxType="Stack">
	<GuidanceCard card={guidanceCardTrainingFigma} mdxType="GuidanceCard" />
	<GuidanceCard card={guidanceCardTrainingADS} mdxType="GuidanceCard" />
	<GuidanceCard card={guidanceCardTrainingA11y} mdxType="GuidanceCard" />
    </Stack>
    <h2 {...{
      "id": "contact-us"
    }}>{`Contact us`}</h2>
    <IconCardGroup data={contactUsCards} mdxType="IconCardGroup" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      